import "./animation.css";

import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import tileAnimation from "../../../assets/tileAnimation.svg";
import content from "../../../assets/content.svg";
import { Navigation } from '../../home/navigation/navigation';
import { useEffect } from "react";

const Animation = () => {
    useEffect(() => {
        document.querySelector("body").style.background = "#fe4406";
        document.documentElement.style.background = "#fe4406";
        const oldColor = document.documentElement.style.getPropertyValue("--txt-color");
        document.querySelector("footer").style.color = "white";
        document.querySelector(".sitemapLink").style.color = "#bbb";
        return () => {
            document.querySelector("body").style.background = null;
            document.documentElement.style.background = null;
            document.querySelector("footer").style.color = oldColor;
            document.querySelector(".sitemapLink").style.color = "#888";
        }
    });
    return (
        <div className={`view animation standalone`}>
           <Navigation/>
            <div className="action top left align-center">
                <Link to={"../services"}><button className="reveal reveal-area action round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
                <Link to={"../portfolio"}><button className="reveal reveal-area round action align-center"><img draggable="false" alt="" width="30" height="30" src={ content }/><span className="optimizeSmall"><FormattedMessage id="titlePortfolio" /></span></button></Link>
            </div>
            <img draggable="false" className="backImage" alt="" src={tileAnimation}/>
            <h2><FormattedMessage id="animation" /></h2>
            <p><FormattedMessage id="text_animation" /></p>
            <div className="animationsContainer align-center">
                <img draggable="false" width="200" alt="" src="./assets/animations/lalisaAnimation.gif"/>
                <Link to="../collections/view?id=animations&ctx=animation">
                    <div className="linkItem align-center">
                        <div className="cover"/>
                        <span><FormattedMessage id="seeMore" /></span>
                    </div></Link>
            </div>
        </div>
    );
}

export default Animation;